import styled from "styled-components"

import GenericModal from "@irati/ui/src/GenericModal"

const StyledModal = styled(GenericModal)`
  .onboarding-slider-list {
    .slick-list {
      transition: height 0.4s ease-in-out;
    }
    .slick-slide {
      visibility: hidden;
      opacity: 0;
      transition: opacity 0.4s ease-in-out;
    }
    .slick-current {
      visibility: visible;
      opacity: 1;
    }
  }
`
export default StyledModal
